import React, { useContext, useEffect, useState } from "react";
import ConfettiExplosion from "react-confetti-explosion";
import { BsPatchCheckFill } from "react-icons/bs";
import { Link, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { FaChevronLeft } from "react-icons/fa";
import { MiniStoreThemeContext } from "../../MiniStoreContexts/MiniStoreThemeContext";
import usePaymentResponse from "../../Components/MiniStore/CheckoutComponents/hooks/usePaymentResponse";
import moment from "moment";
import { RingLoader } from "react-spinners";

const PaymentSuccessful = () => {
  const { handlePaymentPoll, transactionDetail } = usePaymentResponse();

  const { theme } = useContext(MiniStoreThemeContext);
  useEffect(() => {
    handlePaymentPoll();
  }, []);
  function extractTextFromHTML(htmlString) {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = htmlString;
    return tempDiv.textContent || "";
  }
  const displayMessage = transactionDetail?.message_to_display
    ? extractTextFromHTML(transactionDetail.message_to_display)
    : "In Progress...";

  return (
    <>
      <div className="d-flex flex-column justify-content-center align-items-center bg-white h-100 w-100">
        {transactionDetail && <ConfettiExplosion />}
        <h3
          className="d-flex flex-column justify-content-center align-items-center gap-3"
          style={{ fontFamily: "Outfit, sans-serif", textAlign: "center" }}
        >
          <strong style={{ fontSize: "inherit" }}>{displayMessage}</strong>
          {transactionDetail && (
            <BsPatchCheckFill
              style={{ color: "#198754", fontSize: "inherit" }}
            />
          )}
        </h3>

        {transactionDetail ? (
          <div className="mt-4 text-center">
            <h4>Invoice</h4>
            <p>Reference: {transactionDetail.reference}</p>
            <p>
              Amount: {transactionDetail.amount} {transactionDetail.currency}
            </p>
            <p>Payment Method: {transactionDetail.acquirer_provider}</p>
            <p>Payment Status: {transactionDetail.state}</p>

            <p>Date: {moment(new Date()).format("DD-MMM-yyyy")}</p>
          </div>
        ) : (
          <RingLoader color={theme.primaryColor.primary} />
        )}

        {transactionDetail && (
          <ContinueShopping theme={theme} to="/storefront/cart">
            <FaChevronLeft />
            Continue Shopping
          </ContinueShopping>
        )}
      </div>
    </>
  );
};

export default PaymentSuccessful;

const ContinueShopping = styled(Link)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: auto;
  height: 65px;
  border-radius: 0.15rem;
  border-width: 1px;
  border: 1px solid #dee2e6;
  margin: 10px 0px;
  padding: 1.5rem;
  cursor: pointer;
  text-decoration: none !important;
  font-family: Outfit, sans-serif;
  font-weight: 600;
  font-size: 24px;
  line-height: 20px;
  background: ${({ theme }) => theme.textColor.primary};
  color: ${({ theme }) => theme.primaryColor.primary} !important;
  // box-shadow: ${({ theme }) => theme.boxShadow.primary};

  svg {
    color: ${({ theme }) => theme.primaryColor.primary};
    margin: 0px 3px;
  }
  @media (max-width: 375px) {
    font-size: 20px;
  }
`;
